/**
 * Shared New Relic attribute builders for feature events.
 */
export function buildNRErrorExtra(error: unknown): Record<string, string> {
    return {
        errorName: error instanceof Error ? error.name : "unknown",
        errorMessage: error instanceof Error ? error.message : String(error),
    };
}

export function buildNRLatencyMs(startMs: number): number {
    return Date.now() - startMs;
}

/** Failure payload reused across bridge / hydrate / prefetch catch sites. */
export function buildNRFailureAttrs(error: unknown, startMs?: number): Record<string, string> {
    return {
        ...(startMs != null ? { latencyMs: String(buildNRLatencyMs(startMs)) } : {}),
        ...buildNRErrorExtra(error),
    };
}
